import { render, staticRenderFns } from "./AppChart.vue?vue&type=template&id=c627790c&scoped=true&"
import script from "./AppChart.vue?vue&type=script&lang=ts&"
export * from "./AppChart.vue?vue&type=script&lang=ts&"
import style0 from "./AppChart.vue?vue&type=style&index=0&id=c627790c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c627790c",
  null
  
)

export default component.exports